<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!--의견게시기간-->
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            label="LBL0010180"
            name="period"
            v-model="period"
          />
        </div>
      </template>
    </c-search-box>
    <!--종사자 의견청취 목록-->
    <c-table
      ref="table"
      title="안전의견 목록"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      rowKey="boardId"
      :columnSetting="false"
      :expandAll="true"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-qr-btn
            label="경농파트너QR"
            mobileUrl="/outer/safOpinionBoardDetailOuter"
            :isPartner="true"
          ></c-qr-btn>
          <c-qr-btn
            label="경농내부직원QR"
            mobileUrl="/sai/sob/safOpinionBoard"
            :isPartner="false"
          ></c-qr-btn>
          <!--등록-->
          <c-btn
            v-if="editable"
            label="LBLREG"
            icon="add"
            @btnClicked="bookPopup"
          />
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "saf-opinion-board",
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            //사업장
            label: "LBLPLANT",
            align: "center",
            style: "width:80px",
            sortable: true,
          },
          {
            name: "boardTitle",
            field: "boardTitle",
            //제목
            label: "LBLTITLE",
            align: "left",
            type: "link",
            style: "width:150px",
            sortable: true,
          },
          {
            name: "boardContents",
            field: "boardContents",
            //개요
            label: "LBL0010182",
            align: "left",
            style: "width:300px",
            sortable: true,
          },
          {
            name: "boardDate",
            field: "boardDate",
            //의견게시일
            label: "LBL0010183",
            align: "center",
            style: "width:80px",
            sortable: true,
          },
          {
            name: "regName",
            field: "regName",
            //작성자/작성일
            label: "LBLREGUSERNDATE",
            align: "center",
            style: "width:150px",
            sortable: true,
          },
          // {
          //   name: 'attach',
          //   field: 'attach',
          //   label: '관련 파일첨부',
          //   align: 'center',
          //   style: 'width:150px',
          //   type: 'attach',
          //   taskClassCd: 'SOB_BOARD',
          //   keyText: 'boardId',
          //   sortable: true,
          // },
        ],
        data: [],
      },
      searchParam: {
        plantCd: "",
        startYmd: "",
        endYmd: "",
      },
      period: [],
      editable: true,
      listUrl: "",
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      attachInfo: {
        isSubmit: "",
        taskClassCd: "SOB_BOARD",
        taskKey: "",
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.sai.sob.board.list.url;
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = "";
        this.searchParam.endYmd = "";
      }
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    linkClick(row) {
      this.bookPopup(row);
    },
    bookPopup(result) {
      this.popupOptions.target = () =>
        import(`${"./safOpinionBoardDetail.vue"}`);
      this.popupOptions.title = "안전의견 상세"; //종사자 의견청취 상세
      this.popupOptions.param = {
        boardId: result ? result.boardId : "",
      };
      this.popupOptions.width = "95%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
